import React from "react";
import Box from "@mui/material/Box";
import { Button, Grid, LinearProgress, Typography } from "@mui/material";
import { TabContext, TabList } from "@mui/lab";
import Tab from "@mui/material/Tab";
import { useState, useEffect } from "react";
import { Form, Formik } from "formik";
import TabPanel from "@mui/lab/TabPanel";
import useStyles from "./../../styles/styles";
import BranchAddress from "./Forms/BranchAddress";
import BranchContact from "./Forms/BranchContact";
import { BranchApi, EditBranchRequest, GetBranchResponse } from "../../api/clinic-management";
import { configState } from "../../recoil/atoms";
import { useRecoilValue } from "recoil";
import BranchCalendar from "./Forms/BranchCalendar";
import validationSchema from "./FormModel/validationSchema";
import BranchServices from "./Forms/BranchServices";
import useAuthorization from "../Authentication/permissions/Authorization";
import { useParams } from "react-router-dom";
import MainCard from "../../styles/ui-component/cards/MainCard";
import { toast } from "react-toastify";

const EditBranchPage = () => {
  const [selectedTab, setSelectedTab] = useState("0");
  const [branch, setBranch] = useState<GetBranchResponse>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { canEditTenantBranch } = useAuthorization();
  const { branchID } = useParams();

  const classes = useStyles();

  const config = useRecoilValue(configState);

  const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
    setSelectedTab(newValue);
  };

  const currentValidationSchema = validationSchema[parseInt(selectedTab)];

  const getBranch = () => {
    const branch = new BranchApi(config);
    branch
      .getTenantBranchById(branchID!)
      .then((res) => {
        setBranch(res.data!);
        setIsLoading(false);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
        setIsLoading(false);
      });
  };

  const editBranch = (values: any) => {
    const branch = new BranchApi(config);
    branch
      .editTenantBranch(branchID!, values)
      .then((res) => {
        toast.success(res?.data?.Message!);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      });
  };

  useEffect(() => {
    getBranch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = (values: any, actions: any) => {
    actions.setTouched({});
    actions.setSubmitting(false);
    const editedValues: EditBranchRequest = {
      Name: values.Name,
      Address: values.Address,
      Coordinate: values.Coordinate,
      Timezone: values.Timezone,
      Calendar: values.Calendar,
      Contact: values.Contact,
      Services: values.Services,
    };
    editBranch(editedValues);
  };

  return (
    <>
      <MainCard>
        {!isLoading ? (
          <Box sx={{ width: "100%" }}>
            <Box sx={{ bgcolor: "#fff", p: 4 }}>
              <Typography variant="h3" gutterBottom sx={{ p: 0 }}>
                {branch?.Name}
              </Typography>
              <TabContext value={selectedTab}>
                <Box
                  sx={{
                    borderBottom: 1,
                    borderColor: "divider",
                    display: "flex",
                    justifyContent: "center",
                  }}
                  width="100%"
                >
                  <TabList
                    onChange={handleChangeTab}
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    textColor="secondary"
                    indicatorColor="secondary"
                  >
                    <Tab label="Address" value="0" />
                    <Tab label="Calendar" value="1" />
                    <Tab label="Contact" value="2" />
                    <Tab label="Services" value="3" />
                  </TabList>
                </Box>
                <Formik
                  initialValues={branch!}
                  enableReinitialize={true}
                  validationSchema={currentValidationSchema}
                  onSubmit={handleSubmit}
                >
                  {({ isSubmitting }) => (
                    <Form>
                      <TabPanel value="0">
                        <BranchAddress />
                      </TabPanel>
                      <TabPanel value="1">
                        <BranchCalendar />
                      </TabPanel>
                      <TabPanel value="2">
                        <BranchContact />
                      </TabPanel>
                      <TabPanel value="3">
                        <BranchServices />
                      </TabPanel>
                      {canEditTenantBranch && (
                        <Grid
                          container
                          sx={{
                            pt: 8,
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <Grid item>
                            <Button
                              type="submit"
                              variant="contained"
                              color="secondary"
                              className={classes.button}
                              fullWidth
                              //   onClick={() => handleSubmit}
                            >
                              Save
                            </Button>
                          </Grid>
                        </Grid>
                      )}
                    </Form>
                  )}
                </Formik>
              </TabContext>
            </Box>
          </Box>
        ) : (
          <LinearProgress color="secondary" />
        )}
      </MainCard>
    </>
  );
};

export default EditBranchPage;
